import { CircularProgress, Stack, Typography, useTheme } from '@mui/material';

interface IAreaLoaderProps {
  message?: string;
  small?: boolean;
}
const AreaLoader: React.FC<IAreaLoaderProps> = ({ message = 'Загружаю приложение...', small = false }) => {
  const theme = useTheme();
  return (
    <Stack
      alignItems={'center'}
      gap={'5px'}
      sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
    >
      <CircularProgress size={24} sx={{ color: theme.custom.palette.primary.default }} />
      <Typography variant={small ? 'subtitle1' : 'h3'} align={'center'}>
        {message}
      </Typography>
    </Stack>
  );
};

export default AreaLoader;
